export default class ErrorCommentCreation extends Error {
  constructor(...args: any) {
    super(...args);
    this.name = 'ErrorCommentCreation';
    this.message = 'Comment creation not allowed!';

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ErrorCommentCreation);
    }
  }
}
